exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".icon-text[data-v-7fca2984]{margin-top:5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/IconButton.vue"],"names":[],"mappings":"AACA,4BACE,cAAgB,CACjB","file":"IconButton.vue","sourcesContent":["\n.icon-text[data-v-7fca2984] {\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7fca2984","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/IconButton.vue
// module id = 1749
// module chunks = 3 9